<template>
  <div class="scan-history-list">
    <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px;">
      {{title || "历史扫码记录"}}
    </div>
    <span>
      报工时间： <el-date-picker
          v-model="confirmDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"/>
    </span>
    <!-- 日期Tab切换 -->
    <el-tabs v-model="selectedDate" @tab-click="handleDateTabClick">
      <el-tab-pane name="current">
        <template slot="label">
          <span>当前 ({{currentBarcodes.length}})</span>
        </template>
        <!-- 当前的扫码记录 -->
        <div v-if="currentBarcodes.length > 0">
          <el-table :data="currentBarcodes" style="width: 100%" max-height="300" size="mini">
            <el-table-column prop="index" label="序号" width="60" align="center">
              <template slot-scope="scope">{{currentBarcodes.length - scope.$index}}</template>
            </el-table-column>
            <el-table-column prop="barcode" label="条形码">
              <template slot-scope="scope">
                <span>{{scope.row.barcode}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scanTime" label="扫描时间" width="140" align="center">
              <template slot-scope="scope">
                <span>{{formatScanTime(scope.row.scanTime)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="handleEditBarcode(scope.$index, scope.row)">修改</el-button>
                <el-button
                    v-if="$auth(deleteAuthIndex)"
                    type="danger"
                    size="mini"
                    @click="deleteBarcode(scope.$index, scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else style="text-align: center; padding: 20px; color: #999;">
          暂无数据
        </div>
      </el-tab-pane>

      <el-tab-pane name="today">
        <template slot="label">
          <span>今天 ({{todayBarcodes.length}})</span>
        </template>
        <!-- 今天的扫码记录（显示全部数据） -->
        <div v-if="todayBarcodes.length > 0">
          <el-table :data="todayBarcodes" style="width: 100%" max-height="300" size="mini">
            <el-table-column prop="index" label="序号" width="60" align="center">
              <template slot-scope="scope">{{todayBarcodes.length - scope.$index}}</template>
            </el-table-column>
            <el-table-column prop="barcode" label="条形码">
              <template slot-scope="scope">
                <span>{{scope.row.barcode}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scanTime" label="扫描时间" width="140" align="center">
              <template slot-scope="scope">
                <span>{{formatScanTime(scope.row.scanTime)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else style="text-align: center; padding: 20px; color: #999;">
          暂无数据
        </div>
      </el-tab-pane>

      <el-tab-pane name="yesterday">
        <template slot="label">
          <span>昨天 ({{yesterdayBarcodes.length}})</span>
        </template>
        <!-- 昨天的扫码记录 -->
        <div v-if="yesterdayBarcodes.length > 0">
          <el-table :data="yesterdayBarcodes" style="width: 100%" max-height="300" size="mini">
            <el-table-column prop="index" label="序号" width="60" align="center">
              <template slot-scope="scope">{{yesterdayBarcodes.length - scope.$index}}</template>
            </el-table-column>
            <el-table-column prop="barcode" label="条形码">
              <template slot-scope="scope">
                <span>{{scope.row.barcode}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scanTime" label="扫描时间" width="140" align="center">
              <template slot-scope="scope">
                <span>{{formatScanTime(scope.row.scanTime)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else style="text-align: center; padding: 20px; color: #999;">
          暂无数据
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 清空按钮 - 仅当前tab时显示 -->
    <div v-if="selectedDate === 'current'" style="margin-top: 10px; ">
      <!-- 导出配置输入框 -->
      <div style="margin-bottom: 10px; padding: 10px; border: 1px solid #ddd; border-radius: 4px;">
        <div
            style="font-size: 12px; color: #666; margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
          <span>导出配置：</span>
          <el-button
              type="text"
              size="mini"
              style="color: #999; font-size: 11px; padding: 0 5px;"
              @click="clearExportConfig">
            清除配置
          </el-button>
        </div>
        <div>
          <span>文件名称：</span>
          <el-input
              v-model="fileName"
              placeholder="请输入文件名称，如：production_scan"
              size="mini"
              style="width: 280px;"
              @change="saveExportConfig"
          />
        </div>
        <div style="font-size: 11px; color: #999; margin-top: 5px;">
          提示：配置将自动保存到本地，下次访问时自动加载
        </div>
      </div>

      <el-button
          v-if="['PackScan', 'NoNeedSerialNoPackScan'].includes(storageKeyPrefix)"
          type="success"
          size="mini"
          :disabled="isConfirmDisabled"
          :loading="confirmLoading"
          @click="confirmList">
        报工
      </el-button>
      <el-button
          type="primary"
          size="mini"
          :disabled="currentBarcodes.length === 0"
          :loading="exportLoading"
          @click="exportCurrentSNList">
        导出当前记录
      </el-button>
      <el-button
          type="danger"
          size="mini"
          :disabled="isClearDisabled"
          @click="clearTodayHistory">
        清空当前记录
      </el-button>
      <el-button
          v-if="['PackScan'].includes(storageKeyPrefix)"
          type="primary"
          size="mini"
          :loading="printLoading"
          :disabled="currentBarcodes.length === 0"
          @click="handlePrint">
        打印
      </el-button>
      <!-- <el-button
          type="info"
          size="mini"
          @click="generateTestData">
        生成测试数据
      </el-button> -->
    </div>

    <!-- 修改条形码对话框 -->
    <el-dialog
        title="修改条形码"
        :visible.sync="editDialogVisible"
        width="400px"
        top="30vh"
        @close="resetEditForm">
      <el-form
          ref="editForm"
          :model="{ barcode: editBarcode }"
          :rules="editFormRules"
          label-width="80px">
        <el-form-item label="新条形码" prop="barcode">
          <el-input v-model="editBarcode" placeholder="请输入新的条形码"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="resetEditForm">取消</el-button>
        <el-button type="primary" @click="saveEditBarcode">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "ScanHistoryComp",
    props: {
      // 标题
      title: {
        type: String,
        default: "历史扫码记录",
      },
      // localStorage key 前缀（动态传入，用于区分不同页面）
      storageKeyPrefix: {
        type: String,
        required: true,
      },
      // 最大保存天数（默认为7天）
      maxDays: {
        type: Number,
        default: 2,
      },
      // 删除按钮权限索引
      deleteAuthIndex: {
        type: Number,
        default: 999,
      },
    },
    data() {
      return {
        // 历史记录相关数据
        todayBarcodes: [],
        printLoading: false,
        yesterdayBarcodes: [],
        currentBarcodes: [],  // 当前tab的数据
        // 当前选中的Tab
        selectedDate: "current",  // 默认选中"当前"tab
        // 用于记录哪些是新扫描的数据（清空后新增的）
        lastClearTime: null,
        confirmDate: "",
        exportLoading: false,
        confirmLoading: false,
        // 导出配置
        fileName: "",
        // 修改条形码对话框
        editDialogVisible: false,
        editBarcode: "",
        editingItem: null,
        editingIndex: -1,
        // 修改条形码表单验证规则
        editFormRules: {
          barcode: [
            {required: true, message: "请输入新的条形码", trigger: "blur"},
            {min: 1, message: "条形码不能为空", trigger: "blur"},
          ],
        },
      };
    },
    computed: {
      // 计算是否所有条码都已报工
      allReported() {
        return this.currentBarcodes.length > 0 && this.currentBarcodes.every(item => item.isReported === true);
      },
      // 计算报工按钮是否禁用
      isConfirmDisabled() {
        return this.currentBarcodes.length === 0 || this.allReported;
      },
      // 计算清空按钮是否禁用
      isClearDisabled() {
        if (["PackScan", "NoNeedSerialNoPackScan"].includes(this.storageKeyPrefix)) {
          return this.currentBarcodes.length === 0 || !this.allReported;
        } else {
          return this.currentBarcodes.length === 0;
        }
      },
    },
    watch: {
      allReported: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.$emit("update-can-scan", !newVal);
          }
        },
        immediate: true,
      },
    },
    mounted() {
      // 组件挂载时加载历史数据
      this.loadHistoryData();
      this.initData();
      // 加载导出配置
      this.loadExportConfig();

    },
    methods: {
      initData() {
        let date = new Date();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        this.confirmDate = date.getFullYear() + "-" + month + "-" + strDate;
      },
      // 日期格式化
      formatDate(date, isNeedMinutes) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        if (isNeedMinutes) {
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          return `${year}${month}${day}${hours}${minutes}`;
        } else {
          return `${year}-${month}-${day}`;
        }
      },

      // 格式化扫描时间显示
      formatScanTime(isoString) {
        if (!isoString) return "";
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      },

      // 获取昨天日期字符串
      getYesterdayDate() {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return this.formatDate(yesterday);
      },

      // 获取今天日期字符串
      getTodayDate() {
        return this.formatDate(new Date());
      },

      // 获取指定日期的存储key
      getStorageKey(dateStr) {
        return `${this.storageKeyPrefix}_${dateStr}`;
      },

      // 获取当前记录的存储key
      getCurrentBarcodesKey() {
        return `${this.storageKeyPrefix}_9999-99-99`;
      },

      // 清理过期数据
      cleanupOldData() {
        const today = new Date();
        const maxDaysAgo = new Date(today);
        maxDaysAgo.setDate(today.getDate() - this.maxDays);
        const cleanupDateStr = this.formatDate(maxDaysAgo);

        // 遍历localStorage中所有键
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);

          // 处理数据存储键：${storageKeyPrefix}_${dateStr}
          if (key.startsWith(`${this.storageKeyPrefix}_`)) {
            const dateStr = key.substring(`${this.storageKeyPrefix}_`.length);
            // 如果日期字符串小于等于清理日期，则删除
            if (dateStr <= cleanupDateStr) {
              localStorage.removeItem(key);
            }
          }

          // 处理清空时间点键：lastClearTime_${storageKeyPrefix}_${dateStr}
          if (key.startsWith(`lastClearTime_${this.storageKeyPrefix}_`)) {
            const dateStr = key.substring(`lastClearTime_${this.storageKeyPrefix}_`.length);
            // 如果日期字符串小于等于清理日期，则删除
            if (dateStr <= cleanupDateStr) {
              localStorage.removeItem(key);
            }
          }
        }
      },

      // Tab切换处理
      handleDateTabClick(tab) {
        this.selectedDate = tab.name;
      },

      // 加载历史数据
      loadHistoryData() {
        // 清理过期数据
        this.cleanupOldData();

        // 加载今天的全部数据（用于"今天"tab显示全部数据）- 倒序排列
        const todayStorageKey = this.getStorageKey(this.getTodayDate());
        const todayData = localStorage.getItem(todayStorageKey);
        if (todayData) {
          try {
            this.todayBarcodes = JSON.parse(todayData);
          } catch (e) {
            this.todayBarcodes = [];
          }
        } else {
          this.todayBarcodes = [];
        }

        // 加载昨天的数据（昨天数据不参与清空筛选）- 倒序排列
        const yesterdayStorageKey = this.getStorageKey(this.getYesterdayDate());
        const yesterdayData = localStorage.getItem(yesterdayStorageKey);

        if (yesterdayData) {
          try {
            this.yesterdayBarcodes = JSON.parse(yesterdayData);
          } catch (e) {
            this.yesterdayBarcodes = [];
          }
        } else {
          this.yesterdayBarcodes = [];
        }

        // 加载当前数据（基于清空时间点筛选，用于"当前"tab）
        this.loadCurrentBarcodes();
      },

      // 加载当前数据（清空后的数据）
      loadCurrentBarcodes() {
        const currentBarcodesKey = this.getCurrentBarcodesKey();
        const currentData = localStorage.getItem(currentBarcodesKey);
        if (currentData) {
          this.currentBarcodes = JSON.parse(currentData);
        } else {
          this.currentBarcodes = [];
        }

        // if (currentData && this.storageKeyPrefix === "KeyComponents") { 
        //   // 如果是关键工序，则需要手动清空，否则加载当前数据
        // } else {
        //   // 这里需要清空电脑中的历史记录
        //   localStorage.removeItem(currentBarcodesKey);
        //   this.currentBarcodes = [];
        // }
      },

      // 保存条形码到历史记录（供外部调用）
      saveBarcode(barcode, orders, materialNo) {
        // 获取今天的日期作为key的一部分
        const today = this.getTodayDate();
        const storageKey = this.getStorageKey(today);
        // 获取当前需要清空后的数据存储key
        const currentBarcodesKey = this.getCurrentBarcodesKey();

        // 获取今天的历史数据
        let historyData = [];
        const existingData = localStorage.getItem(currentBarcodesKey);
        if (existingData) {
          try {
            historyData = JSON.parse(existingData);
          } catch (e) {
            console.error("解析历史数据失败:", e);
          }
        }

        // 检查是否已存在相同的条形码，避免重复添加
        const exists = historyData.some(item => item.barcode === barcode);
        if (!exists) {
          const newItem = {
            barcode: barcode,
            scanTime: new Date().toISOString(),
            orders: orders,
            materialNo: materialNo,
            isReported: false,
          };
          // 更新todayBarcodes（今天tab显示全部数据）- 最新数据放在最前面
          this.todayBarcodes.unshift(newItem);
          localStorage.setItem(storageKey, JSON.stringify(this.todayBarcodes));

          // 更新当前的tab
          this.currentBarcodes.unshift(newItem);
          localStorage.setItem(currentBarcodesKey, JSON.stringify(this.currentBarcodes));
          // 如果是打包扫码，确认报工
          // if (this.storageKeyPrefix === "PackScan") {
          //   this.confirmList();
          // }
        }
      },

      // 清空今天的历史记录
      clearTodayHistory() {
        this.$confirm("确定要清空今天的历史扫码记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // 清空当前tab显示的数据
          this.currentBarcodes = [];
          // 清空单独存储的当前记录key
          const currentBarcodesKey = this.getCurrentBarcodesKey();
          localStorage.removeItem(currentBarcodesKey);
          this.$message.success("历史记录已清空");
        }).catch(() => {
          // 用户取消
        });
      },

      // 打印记录
      handlePrint() {
        this.printLoading = true;
        this.$http.post("basic", "printerMaterials/autoPrint", this.currentBarcodes)
          .then(resp => {
            if (resp.success) {
              this.$message.success("打印成功");
            }
          }).finally(() => {
            this.printLoading = false;
          });
      },

      // 清除导出配置
      clearExportConfig() {
        this.$confirm("确定要清除导出配置吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.fileName = "";
          // 清除localStorage中的配置
          const fileNameKey = `fileName_${this.storageKeyPrefix}`;
          localStorage.removeItem(fileNameKey);
          this.$message.success("导出配置已清除");
        }).catch(() => {
          // 用户取消
        });
      },

      // 加载导出配置
      loadExportConfig() {
        const fileNameKey = `fileName_${this.storageKeyPrefix}`;
        const savedFileName = localStorage.getItem(fileNameKey);
        if (savedFileName) {
          this.fileName = savedFileName;
        }
      },

      // 保存导出配置
      saveExportConfig() {
        const fileNameKey = `fileName_${this.storageKeyPrefix}`;
        if (this.fileName) {
          localStorage.setItem(fileNameKey, this.fileName);
        }
      },

      // 删除指定的条形码记录
      deleteBarcode(index, row) {
        this.$confirm("确定要删除这条记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // 从currentBarcodes数组中删除
          this.currentBarcodes.splice(index, 1);

          // 从今天的完整数据中删除并更新localStorage
          const today = this.getTodayDate();
          const storageKey = this.getStorageKey(today);
          const todayData = localStorage.getItem(storageKey);

          if (todayData) {
            try {
              let historyData = JSON.parse(todayData);
              // 找到并删除对应的记录
              const recordIndex = historyData.findIndex(item => item.barcode === row.barcode);
              if (recordIndex !== -1) {
                historyData.splice(recordIndex, 1);
                localStorage.setItem(storageKey, JSON.stringify(historyData));
                // 更新todayBarcodes
                this.todayBarcodes = [...historyData];
              }
            } catch (e) {
              console.error("更新历史数据失败:", e);
            }
          }
          // 更新单独存储的当前记录key
          const currentBarcodesKey = this.getCurrentBarcodesKey();
          localStorage.setItem(currentBarcodesKey, JSON.stringify(this.currentBarcodes));
          this.$message.success("记录删除成功");
        }).catch(() => {
          // 用户取消
        });
      },

      // 打开修改条形码对话框
      handleEditBarcode(index, row) {
        this.editingIndex = index;
        this.editingItem = {...row};
        this.editBarcode = row.barcode;
        this.editDialogVisible = true;
      },

      // 重置修改条形码表单
      resetEditForm() {
        this.editDialogVisible = false;
        this.editBarcode = "";
        this.editingItem = null;
        this.editingIndex = -1;
      },

      // 保存修改后的条形码
      saveEditBarcode() {
        // 验证表单
        if (!this.editBarcode || this.editBarcode.trim() === "") {
          this.$message.error("请输入新的条形码");
          return;
        }

        // 检查新条形码是否与其他记录重复
        const isDuplicate = this.currentBarcodes.some((item, idx) => {
          return item.barcode === this.editBarcode && idx !== this.editingIndex;
        });
        if (isDuplicate) {
          this.$message.error("新条形码与其他记录重复，请重新输入");
          return;
        }

        // 更新currentBarcodes中的记录
        const oldBarcode = this.currentBarcodes[this.editingIndex].barcode;
        this.currentBarcodes[this.editingIndex].barcode = this.editBarcode;

        // 更新localStorage中的当前记录
        const currentBarcodesKey = this.getCurrentBarcodesKey();
        localStorage.setItem(currentBarcodesKey, JSON.stringify(this.currentBarcodes));

        // 更新今天的历史记录
        const today = this.getTodayDate();
        const storageKey = this.getStorageKey(today);
        const todayData = localStorage.getItem(storageKey);

        if (todayData) {
          try {
            let historyData = JSON.parse(todayData);
            // 找到并更新对应的记录
            const recordIndex = historyData.findIndex(item => item.barcode === oldBarcode);
            if (recordIndex !== -1) {
              historyData[recordIndex].barcode = this.editBarcode;
              localStorage.setItem(storageKey, JSON.stringify(historyData));
              // 更新todayBarcodes
              this.todayBarcodes = [...historyData];
            }
          } catch (e) {
            console.error("更新历史数据失败:", e);
          }
        }

        this.$message.success("条形码修改成功");
        this.resetEditForm();
      },

      // 校验导出配置
      validateExportConfig() {
        if (!this.fileName || this.fileName.trim() === "") {
          this.$message.warning("请填写文件名称");
          return false;
        }
        return true;
      },

      exportCurrentSNList() {
        // 校验导出配置
        if (!this.validateExportConfig()) {
          return;
        }
        this.exportLoading = true;
        this.$http.postForFile("basic", "sapProductionOrders/exportPackList", this.currentBarcodes)
          .then(async(res) => {
            const blob = new Blob([res.data]);
            // const fullFileName = `${this.fileName}_${this.formatDate(new Date(), true)}.csv`;
            this.fallbackDownload(blob, this.fileName);
            this.$message.success("文件已下载");
            this.exportLoading = false;
          }).catch(() => {
            this.exportLoading = false;
          });
      },

      // 降级下载方案
      fallbackDownload(blob, fileName) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },

      // 报工
      confirmList() {
        this.confirmLoading = true;
        let params = {
          confirmDate: this.confirmDate,
          snList: this.currentBarcodes,
        };

        let url = "";
        if (this.storageKeyPrefix === "PackScan") {
          url = "sapProductionOrders/confirmBySnList";
        } else if (this.storageKeyPrefix === "NoNeedSerialNoPackScan") {
          url = "sapProductionOrders/confirmNoNeedSerialNoBySnList";
        }

        if (url !== "") {
          this.$http.post("basic", url, params)
            .then(resp => {
              if (resp.success) {
                this.$message.success(resp.data);
                // 将currentBarcodes中的所有条码标记为已报工
                this.currentBarcodes.forEach(item => {
                  item.isReported = true;
                });
                // 更新localStorage中的数据
                const currentBarcodesKey = this.getCurrentBarcodesKey();
                localStorage.setItem(currentBarcodesKey, JSON.stringify(this.currentBarcodes));
              }
            }).finally(() => {
              this.confirmLoading = false;
            });
        } else {
          this.$message.error("未定义的变量");
        }


      },

      // 生成测试数据
      generateTestData() {
        // 生成10条测试数据
        const testData = [];
        const today = this.getTodayDate();
        const yesterday = this.getYesterdayDate();

        // 生成今天的测试数据
        for (let i = 1; i <= 5; i++) {
          const item = {
            barcode: `TEST${today.replace(/-/g, "")}${String(i).padStart(3, "0")}`,
            scanTime: new Date(Date.now() - (60 * 60 * 1000 * i)).toISOString(), // 过去i小时的时间
            orders: [`订单号${i}`, `订单号${i + 1}`],
            materialNo: `物料${i}`,
            isReported: false,
          };
          testData.unshift(item);
        }

        // 保存今天的数据到localStorage
        const todayStorageKey = this.getStorageKey(today);
        localStorage.setItem(todayStorageKey, JSON.stringify(testData));

        // 保存昨天的数据到localStorage
        const yesterdayStorageKey = this.getStorageKey(yesterday);
        localStorage.setItem(yesterdayStorageKey, JSON.stringify(testData));

        // 更新组件数据
        this.todayBarcodes = (testData);
        this.yesterdayBarcodes = (testData);
        this.currentBarcodes = (testData); // 当前tab显示今天的全部数据
        const currentBarcodesKey = this.getCurrentBarcodesKey();
        localStorage.setItem(currentBarcodesKey, JSON.stringify(testData));
        this.$message.success(`已生成${testData.length}条测试数据`);
      },
    },
  };
</script>

<style lang="scss" scoped>
.scan-history-list {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #ddd;
  flex: 1;
  min-width: 600px;
  overflow: auto;
}
</style>